/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskExecutionResponse
 */
export interface TaskExecutionResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskExecutionResponse
     */
    taskExecutionId: number;
    /**
     * 
     * @type {number}
     * @memberof TaskExecutionResponse
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskExecutionResponse
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof TaskExecutionResponse
     */
    durationMilliseconds: number;
    /**
     * 
     * @type {Date}
     * @memberof TaskExecutionResponse
     */
    startedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TaskExecutionResponse
     */
    finishedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TaskExecutionResponse
     */
    taskStatus: string;
    /**
     * 
     * @type {Date}
     * @memberof TaskExecutionResponse
     */
    recordCreationTime: Date;
}

/**
 * Check if a given object implements the TaskExecutionResponse interface.
 */
export function instanceOfTaskExecutionResponse(value: object): value is TaskExecutionResponse {
    if (!('taskExecutionId' in value) || value['taskExecutionId'] === undefined) return false;
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('durationMilliseconds' in value) || value['durationMilliseconds'] === undefined) return false;
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    if (!('finishedAt' in value) || value['finishedAt'] === undefined) return false;
    if (!('taskStatus' in value) || value['taskStatus'] === undefined) return false;
    if (!('recordCreationTime' in value) || value['recordCreationTime'] === undefined) return false;
    return true;
}

export function TaskExecutionResponseFromJSON(json: any): TaskExecutionResponse {
    return TaskExecutionResponseFromJSONTyped(json, false);
}

export function TaskExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskExecutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskExecutionId': json['task_execution_id'],
        'taskId': json['task_id'],
        'userId': json['user_id'],
        'durationMilliseconds': json['duration_milliseconds'],
        'startedAt': (json['started_at'] == null ? null : new Date(json['started_at'])),
        'finishedAt': (json['finished_at'] == null ? null : new Date(json['finished_at'])),
        'taskStatus': json['task_status'],
        'recordCreationTime': (new Date(json['record_creation_time'])),
    };
}

export function TaskExecutionResponseToJSON(json: any): TaskExecutionResponse {
    return TaskExecutionResponseToJSONTyped(json, false);
}

export function TaskExecutionResponseToJSONTyped(value?: TaskExecutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_execution_id': value['taskExecutionId'],
        'task_id': value['taskId'],
        'user_id': value['userId'],
        'duration_milliseconds': value['durationMilliseconds'],
        'started_at': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'finished_at': value['finishedAt'] == null ? value['finishedAt'] : value['finishedAt'].toISOString(),
        'task_status': value['taskStatus'],
        'record_creation_time': value['recordCreationTime'].toISOString(),
    };
}

